import {
  localErrorsVar,
} from './variables';

export const localErrors = () => {
  return localErrorsVar();
}